import React from 'react';
import {
    RadialBarChart,
    RadialBar,
    ResponsiveContainer,
    Legend,
    Tooltip,
} from 'recharts';
import StatisticsGlassCard from './StatisticsGlassCard';
import StatisticsDesktopSectionHeader from './StatisticsDesktopSectionHeader';
import { STATS_ICONS } from './statisticsAssets';
import useChartContainerReady from './useChartContainerReady';

const BAR_COLORS = ['#354F38', '#10B981', '#3B82F6', '#F59E0B', '#8B5CF6'];

export default function StatisticsDesktopCapabilityRadialCard({
    capabilityRadar,
    isEditMode,
    longPressHandlers,
}) {
    const { containerRef, isReady } = useChartContainerReady();
    const scores = capabilityRadar?.scores || [];

    const chartData = scores.map((item, i) => ({
        name: item.label,
        value: item.score,
        fill: BAR_COLORS[i % BAR_COLORS.length],
    }));

    return (
        <StatisticsGlassCard className="h-full p-5 flex flex-col" {...longPressHandlers} isEditMode={isEditMode}>
            <StatisticsDesktopSectionHeader
                iconSrc={STATS_ICONS.target}
                title="역량 지표 게이지"
                badge="RADIAL"
            />

            <div ref={containerRef} className="flex-1 min-h-[180px] min-w-0">
                {chartData.length > 0 ? (
                    isReady ? (
                        <ResponsiveContainer width="100%" height="100%">
                            <RadialBarChart
                                innerRadius="20%"
                                outerRadius="90%"
                                data={chartData}
                                startAngle={180}
                                endAngle={0}
                                barSize={10}
                            >
                                <RadialBar
                                    background={{ fill: '#F3F4F6' }}
                                    dataKey="value"
                                    cornerRadius={5}
                                    animationDuration={1200}
                                />
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: '#fff',
                                        border: '1px solid #E5E7EB',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                                        padding: '8px 12px',
                                        fontSize: '12px',
                                        fontWeight: 700,
                                    }}
                                    formatter={(value, name) => [`${value}점`, name]}
                                />
                                <Legend
                                    iconSize={8}
                                    iconType="circle"
                                    wrapperStyle={{ fontSize: '10px', fontWeight: 'bold', paddingTop: '4px' }}
                                    formatter={(value) => <span style={{ color: '#6B7280' }}>{value}</span>}
                                />
                            </RadialBarChart>
                        </ResponsiveContainer>
                    ) : null
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-300 font-bold">
                        <div className="text-center">
                            <div className="text-3xl mb-2">🎯</div>
                            <p className="text-sm">역량 데이터가 없습니다</p>
                        </div>
                    </div>
                )}
            </div>
        </StatisticsGlassCard>
    );
}
